import { render } from "./milestone-form-plan.vue?vue&type=template&id=566c991a&ts=true"
import script from "./milestone-form-plan.vue?vue&type=script&lang=ts"
export * from "./milestone-form-plan.vue?vue&type=script&lang=ts"

import "./milestone-form-plan.vue?vue&type=style&index=0&id=566c991a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__